import React from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useLang } from "../../../../Hooks";
import { useAutoTableHeight } from "../../Shared/Hooks/useAutoTableHeight";
import { BalanceSheetRow } from "./BalanceSheetRow";

export const BalanceSheetTable = ({ data, isLoading, onToggleRow }) => {
  const { texts } = useLang();
  const isRTL = texts.en === "Arabic";
  const tableHeight = useAutoTableHeight(150);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" h="360px">
        <Spinner />
        <Text ms={2}>{texts.reports?.loadingReport || "Loading report..."}</Text>
      </Flex>
    );
  }

  if (!data?.headers?.length || !data?.treeData?.length) {
    return (
      <Flex justify="center" align="center" h="240px">
        <Text color="var(--text-muted)">
          {texts.reports?.noDataAvailable || "No data available"}
        </Text>
      </Flex>
    );
  }

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="#eaeef2"
      borderRadius="lg"
      boxShadow="sm"
      height={`${tableHeight}px`}
      position="relative"
    >
      <Box position="absolute" inset={0} overflow="auto">
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            direction: isRTL ? "rtl" : "ltr",
          }}
        >
          <thead>
            <tr style={{ position: "sticky", top: 0, zIndex: 10, background: "#f5f7fa" }}>
              {data.headers.map((header, index) => (
                <th
                  key={header}
                  style={{
                    padding: "6px",
                    textAlign: index === 0 ? (isRTL ? "right" : "left") : isRTL ? "left" : "right",
                    minWidth: index === 0 ? "300px" : "120px",
                    borderInlineEnd: index === 0 ? "1px solid #dce1e6" : "none",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.treeData.map((row) => (
              <BalanceSheetRow key={row.id} row={row} onToggle={onToggleRow} isRTL={isRTL} />
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};
